import * as React from "react";
import { CodeEditorModal } from "../../../../components/modals/codeEditorModal";
import { EnvVar } from "../../../../schema/types/env";
import { envInputToText, envToInput } from "../utils/envVar";
import { formSet, formSetValue, useCpFormValue } from "../../../gvc/testNewForm/utils";
import { useCpFormContext } from "../../../../components/form/useCpFormContext";
import { store } from "../../../../store";

interface Props {
  index: number;
  isOpen: boolean;
  onClose: any;
}
export const EnvVarsEditor: React.FC<Props> = ({ isOpen, index, onClose }) => {
  const { id } = useCpFormContext();

  const envVars = useCpFormValue(`containers.${index}.env`);
  const envVarsText = React.useMemo(() => {
    if (!isOpen) {
      return ``;
    }
    return envInputToText(envVars);
  }, [envVars, isOpen]);

  if (!isOpen) {
    return null;
  }

  return (
    <CodeEditorModal
      initialValue={envVarsText}
      onClose={() => {
        onClose();
      }}
      onOk={(value: string) => {
        const envVar: EnvVar[] = [];
        for (const line of value.split(`\n`)) {
          if (!line.includes("=")) {
            envVar.push({ name: line, value: "" });
            continue;
          }
          const equalIndex = line.indexOf("=");
          const name = line.slice(0, equalIndex);
          const value = line.slice(equalIndex + 1);
          envVar.push({ name: name, value: value });
        }
        const envVarInput = envToInput(envVar);
        formSetValue(id, `containers.${index}.env`, envVarInput);
        const form = store.getState().form.instances[id];
        formSet(id, `meta.onChangeCounter`, form.meta.onChangeCounter + 1);
        onClose();
      }}
      open={isOpen}
      title="Environment Variables Editor"
      explanation={
        <div className="text-xs">
          <div className="font-semibold mb-1">Format:</div>
          <div>KEY=value (one per line)</div>
          <div className="mt-1 opacity-75">Content will replace existing data</div>
        </div>
      }
    />
  );
};
